/**
 * Helpers for reading RTK Query / fetchBaseQuery errors.
 *
 * Authorization in the backends is codename-based (RawModelPermission) and fails
 * closed: a user missing one raw permission gets a plain 403 with no body worth
 * showing. Surfacing that as the generic "…failed" toast tells the user nothing
 * they can act on — they need to know it is a permission, not a bug or bad input,
 * so they can ask an admin for it.
 */

/** True when an unknown error value is an HTTP 403 from fetchBaseQuery. */
export const isForbiddenError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'status' in error &&
  (error as {status?: unknown}).status === 403
